import * as React from "react";
import type { SVGProps } from "react";
const SvgTeacher = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={36}
    height={36}
    fill="none"
    {...props}
  >
    <path
      fill="#79AFFF"
      d="M27.57 19.26v7.395c0 1.905-1.485 3.945-3.27 4.545l-4.785 1.59c-.84.285-2.205.285-3.03 0L11.7 31.2c-1.8-.6-3.27-2.64-3.27-4.545l.015-7.395 6.63 4.32c1.62 1.065 4.29 1.065 5.91 0l6.585-4.32Z"
      opacity={0.4}
    />
    <path
      fill="#79AFFF"
      d="m29.97 9.69-8.985-5.895c-1.62-1.065-4.29-1.065-5.91 0L6.045 9.69c-2.895 1.875-2.895 6.12 0 8.01l2.4 1.56 6.63 4.32c1.62 1.065 4.29 1.065 5.91 0l6.585-4.32 2.055-1.35v4.59c0 .615.51 1.125 1.125 1.125s1.125-.51 1.125-1.125v-7.38c.6-1.935-.015-4.185-1.905-5.43Z"
    />
  </svg>
);
export default SvgTeacher;
